import { queryKeys } from '@/api/query-keys'
import { portraitsService } from '@/api/services/portraits.service'
import { type PortraitListQueryOptions, usePortraitListQuery } from './use-portrait-list-query'

/** The job's custom groups (clubs, teams, programs) for the Custom dropdown, in the order the API
 *  returns them. */
export function usePortraitCustomCategoriesQuery({ enabled }: PortraitListQueryOptions = {}) {
  return usePortraitListQuery({
    queryKey: queryKeys.portraits.customCategories(),
    queryFn: () => portraitsService.getCustomCategories(),
    enabled,
  })
}
